import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-work-sierra',
  templateUrl: './work-sierra.component.html',
  styleUrls: ['./work-sierra.component.scss']
})

export class WorkSierraComponent implements OnInit {

  constructor() {}

  ngOnInit() {
  }

  //Image 100% width container
  imgContainerAlt = 'wireframes';
  imgContainerUrl = 'assets/img/sierra/wireframes.jpg';

  //Project overview devices
  projectImgDevices = 'assets/img/sierra/sierra-devices.png';
  altImgDevicesTitle = 'Sierra Webpage'
}



// WEBPACK FOOTER //
// ./src/app/work-sierra/work-sierra.component.ts